import { ShareTaskDocument, ShareTaskMutationVariables } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useShareTask = () => {
  const [shareTask, { loading }] = useMutation(ShareTaskDocument, {
    extractorFn: (data) => data.tasksMutations.shareTasksShareTask,
  })

  return {
    shareTask: (variables: ShareTaskMutationVariables) => {
      return shareTask({
        variables,
      })
    },
    loading,
  }
}
